module.exports = __webpack_public_path__ + "img/we-got-a-problem.97451eb2.svg";